var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsCloseOutlineBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2D2D2D;}\r\n\t.st1{fill:#7D7D7D;}\r\n\t.st2{fill:#464646;}\r\n\t.st3{fill:#D04A02;}\r\n\t.st4{fill:#E0301E;}\r\n\t.st5{fill:#DB536A;}\r\n\t.st6{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1_12_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons_x2F_outline_x2F_Home_x5F_32_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_ol_Home_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline-v2_21_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home_4_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Page-1_13_",
    points: "83.8,13.5 52,45.3 20.2,13.5 16,17.7 47.8,49.5 16,81.3 20.2,85.5 52,53.7 83.8,85.5  88,81.3 56.2,49.5 88,17.7  "
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsCloseOutlineBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_Close_Outline_Black_RGB.15425920df0264c7205607560cca332c.svg";
export { ForwardRef as ReactComponent };